import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Buyfullpromotionlist from '../entities/product';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';

interface BuyfullpromotionlistState extends ListState<Buyfullpromotionlist> {
    editBuyfullpromotionlist: Buyfullpromotionlist;
}
class BuyfullpromotionlistModule extends ListModule<BuyfullpromotionlistState, any, Buyfullpromotionlist> {
    public state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Buyfullpromotionlist>(),
        loading: false,
        editTemplate: new Buyfullpromotionlist(),
    };
    public actions = {
        async getAll(context: ActionContext<BuyfullpromotionlistState, any>, payload: any) {
            context.state.loading = true;
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/BuyFullPromotion/GetBuyFullPromotionList', {params: payload.data});
            context.state.loading = false;
            const page = reponse.data.result as PageResult<Buyfullpromotionlist>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getDetail(context: ActionContext<BuyfullpromotionlistState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/BuyFullPromotion/GetBuyFullPromotionDetail?buy=' + payload.data.id +
            '&goodsno=' + payload.data.itemno);
            return reponse.data.result as Buyfullpromotionlist;
        },
        //活动分离 满减
        async getDetail_BuyFull(context: ActionContext<BuyfullpromotionlistState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/MobileBuyFull/GetBuyFullPromotionDetail?buy=' + payload.data.id +
            '&goodsno=' + payload.data.itemno);
            return reponse.data.result as Buyfullpromotionlist;
        },
        //活动分离 满减
        async getAll_Mobile(context: ActionContext<BuyfullpromotionlistState, any>, payload: any) {
            context.state.loading = true;
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/MobileBuyFull/GetBuyFullPromotionList', {params: payload.data});
            context.state.loading = false;
            const page = reponse.data.result as PageResult<Buyfullpromotionlist>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        //获取满减限购
        async get_BuyFullLimity(context: ActionContext<BuyfullpromotionlistState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/MobileBuyFull/GetBuyLimitNumber?itemnos=' + payload.data.itemnos+'&itemactivitieId='+payload.data.itemactivitieId);
            return reponse.data.result;
        },
    };
    public mutations = {
        setCurrentPage(state: BuyfullpromotionlistState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BuyfullpromotionlistState, pagesize: number) {
            state.pageSize = pagesize;
        },
        // tslint:disable-next-line:no-shadowed-variable
        edit(state: BuyfullpromotionlistState, Buyfullpromotionlist: Buyfullpromotionlist) {
            state.editBuyfullpromotionlist = Buyfullpromotionlist;
        },
    };
}
const buyfullpromotionlistModule = new BuyfullpromotionlistModule();
export default buyfullpromotionlistModule;
